import { ErrorAlert } from "@/shared/components/index.js";

const RefetchDataOnError = ({ refetch }: { refetch: () => void }) => {
  return (
    <div className="relative">
      <ErrorAlert
        reload={refetch}
        show={true}
        isFixed={false}
        className="flex min-h-32 flex-wrap items-center justify-center gap-4"
      />
    </div>
  );
};

export default RefetchDataOnError;
